import { Grid, GridItem, useTheme } from '@chakra-ui/react';

import { Text } from 'ui';

const ShopCartHeader = () => {
  const {
    colors: {
      palette: {
        shop: {
          cart: { detailsStep: styles }
        }
      }
    }
  } = useTheme();

  return (
    <Grid
      templateColumns='repeat(12, 1fr)'
      py='10px'
      columnGap='10px'
      display={{ base: 'none', lg: 'grid' }}
      px='12px'
    >
      <GridItem colSpan={7}>
        <Text
          fontSize='12px'
          color={styles.packageText}
          textTransform='uppercase'
        >
          Item
        </Text>
      </GridItem>

      <GridItem colSpan={2}>
        <Text
          fontSize='12px'
          color={styles.qtyText}
          textTransform='uppercase'
          textAlign='center'
        >
          QTY
        </Text>
      </GridItem>
      <GridItem colSpan={2}>
        <Text
          fontSize='12px'
          color={styles.totalText}
          textTransform='uppercase'
          textAlign='end'
        >
          Total
        </Text>
      </GridItem>
      <GridItem colSpan={1} />
    </Grid>
  );
};

export default ShopCartHeader;
